import core from './commuCore'
const output = {}

/* —————————————————————— 摘要相关api —————————————————————— */
// 导出标签信息
function exportLabels () {
  return core.ajax({}, '/brief/exportLabels', 'get')
}
output.exportLabels = exportLabels
// 保存摘要
function saveBrief (data, method) {
  return core.ajax(data, '/brief', method)
}
output.saveBrief = saveBrief

// 获取摘要
function getBrief (data) {
  return core.ajax(data, '/brief', 'get')
}
output.getBrief = getBrief

function updateBrief (data) {
  return core.ajax(data, '/brief', 'put')
}
output.updateBrief = updateBrief

function checkReport (data) {
  return core.ajax(data, '/brief/check', 'get')
}
output.checkReport = checkReport

function repairReport (data) {
  return core.ajax(data, '/brief/repair', 'put')
}
output.repairReport = repairReport

// 提交审阅
function briefReview (data) {
  return core.ajax(data, '/brief/review', 'put')
}
output.briefReview = briefReview

function deleteBrief (briefId) {
  return core.ajax(briefId, '/brief', 'delete')
}
output.deleteBrief = deleteBrief
// 报告中心列表显示
function getReportPage (data) {
  console.log(data, 'data')
  return core.ajax(data, '/brief/getReportPage', 'get')
}
output.getReportPage = getReportPage

function searchBriefTitle (data) {
  return core.ajax(data, '/brief/searchBriefTitle', 'get')
}
output.searchBriefTitle = searchBriefTitle

function searchWriting (data) {
  return core.ajax(data, '/brief/searchWriting', 'get')
}
output.searchWriting = searchWriting

function getCount (data) {
  return core.ajax(data, '/brief/getCount', 'put')
}
output.getCount = getCount

/* —————————————————————— 目录相关api —————————————————————— */
function getOutline (data) {
  return core.ajax(data, '/outline', 'get')
}
output.getOutline = getOutline

function saveOutline (data) {
  return core.ajax(data, '/outline', 'post')
}
output.saveOutline = saveOutline

function getOneOutline (data) {
  return core.ajax(data, '/outline/getOneOutline', 'get')
}
output.getOneOutline = getOneOutline

// 日志
function createBriefLog (data) {
  return core.ajax(data, '/brief/reportLog', 'post')
}
output.createBriefLog = createBriefLog

function getBriefLogList (data) {
  return core.ajax(data, '/brief/reportLog', 'get')
}
output.getBriefLogList = getBriefLogList

function delBriefLog (data) {
  return core.ajax(data, '/brief/reportLog', 'delete')
}
output.delBriefLog = delBriefLog

function updateBriefLog (data) {
  return core.ajax(data, '/brief/reportLog', 'put')
}
output.updateBriefLog = updateBriefLog

function downloadLogFile (data) {
  return core.ajax(data, '/brief/downloadLogFile', 'post')
}
output.downloadLogFile = downloadLogFile

/* -------------------PDF相关API---------------------- */
function createBriedRelativePDF (data) {
  return core.ajax(data, '/brief/reportPDF', 'post')
}
output.createBriedRelativePDF = createBriedRelativePDF

function getPDFList (data) {
  return core.ajax(data, './brief/getPDFList', 'get')
}
output.getPDFList = getPDFList

function delPDF (data) {
  return core.ajax(data, '/brief/delPDF', 'delete')
}
output.delPDF = delPDF

function downloadPDF (data) {
  return core.ajax(data, '/brief/downloadPDF', 'post')
}
output.downloadPDF = downloadPDF

export default output
